import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const EU_COUNTRIES = [
    'SK', 'DE', 'FR', 'PL', 'ES', 'IT', 'NL', 'BE', 'CZ',
    'HU', 'AT', 'SE', 'DK', 'RO', 'FI', 'BG', 'SI', 'HR', 'PT', 'UK'
];

const GeoCookieConsent = () => {
    const [showBanner, setShowBanner] = useState(null); // No type needed

    useEffect(() => {
        const country = Cookies.get('user-country') || 'US';

        if (Cookies.get('cookie_consent')) return; // already chosen → no banner

        if (EU_COUNTRIES.includes(country)) {
            setShowBanner('eu');
        } else if (country === 'US') {
            setShowBanner('us');
        } else {
            setShowBanner('simple');
        }
    }, []);

    const handleAccept = () => {
        Cookies.set('cookie_consent', 'accepted', { expires: 365 });
        console.log('Consent accepted');
        setShowBanner(null); // ✅ hide banner
    };

    const handleDecline = () => {
        Cookies.set('cookie_consent', 'declined', { expires: 365 });
        console.log('Consent declined');
        setShowBanner(null); // ✅ hide banner
    };

    if (!showBanner) return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                width: '100%',
                background: '#2b373b',
                color: '#fff',
                padding: '1rem',
                zIndex: 999
            }}
        >
            {showBanner === 'eu' && (
                <>
                    <p>
                        We use cookies to improve site functionality, analytics and marketing. You can choose which cookies to allow.
                    </p>
                    <button onClick={handleAccept} style={{ marginRight: 10 }}>
                        Accept
                    </button>
                    <button onClick={handleDecline}>Reject</button>
                </>
            )}
            {showBanner === 'us' && (
                <>
                    <p>This site uses cookies to enhance your experience. You may opt out via browser settings.</p>
                    <button onClick={handleAccept}>OK</button>
                </>
            )}
            {showBanner === 'simple' && (
                <>
                    <p>This site uses cookies. By continuing to browse, you accept our use of cookies.</p>
                    <button onClick={handleAccept}>OK</button>
                </>
            )}
        </div>
    );
};

export default GeoCookieConsent;